import { useState, useContext } from "react";
import { Link } from 'react-router-dom';
import useFetch from "../hooks/useFetch";
import StudyList from "./StudyList";
import { AuthContext } from '../App';
import './DicomWeb.css';

const DicomWeb = () => {
    const { apiBaseUrl, token } = useContext(AuthContext);
    const buildQuery = (params) => {
        const qs = new URLSearchParams();
        Object.entries(params).forEach(([k, v]) => { if (v) qs.set(k, v); });
        const s = qs.toString();
        return s ? `?${s}` : '';
    };

    const [queryUrl, setQueryUrl] = useState(null);
    const { data: results, isLoading, error } = useFetch(queryUrl, token);

    const statsUrl = `${apiBaseUrl}/stats`;
    const { data: stats, isLoading: statsLoading, error: statsError } = useFetch(statsUrl, token);

    const [form, setForm] = useState({ PatientName: '', PatientID: '', StudyDate: '', Modality: '', StudyDescription: '' });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
    const handleSearch = (e) => {
        e.preventDefault();
        if (serverUnreachable) return;
        if (!Object.values(form).some(v => v.trim())) return;
        setQueryUrl(`${apiBaseUrl}/qido/studies${buildQuery(form)}`);
    };

    const serverUnreachable = Boolean(statsError) || (!statsLoading && !stats);

    return (
        <div className="home">
            {serverUnreachable ? (
                <div className="server-warning">
                    <strong>Warning:</strong> Ensure that the DCM Server is running at <code>{apiBaseUrl}</code>. If it is not running, please check the deployment status.
                </div>
            ) : (
                stats && (
                    <div className="server-ok">
                        <strong>DCM Server is reachable,</strong>{' '}Found <strong>{stats.patients}</strong> {stats.patients === 1 ? 'Patient' : 'Patients'}, <strong>{stats.studies}</strong> {stats.studies === 1 ? 'Study' : 'Studies'}, and <strong>{stats.series}</strong> {stats.series === 1 ? 'Series' : 'Series'} stored. 
                        <br/>
                        You can <strong>query</strong> or <strong>upload more</strong> DICOM data.
                    </div>
                )
            )}

            <h2>Upload DICOM Files</h2>
            <p>Use this section to upload DICOM files to the server using STOW-RS.</p>
            <br/>
            <div className="upload-section">
                {serverUnreachable ? (
                    <button
                        type="button"
                        className="btn-primary disabled"
                        disabled
                        aria-disabled
                        title="DCM server unreachable"
                    >
                        Upload DICOM Files
                    </button>
                ) : (
                    <Link to="/dicom-web/upload" className="btn-primary">Upload DICOM Files</Link>
                )}
            </div>
            <br/>
            <br/>

            <h2>Search DICOM Studies</h2>
            <p>Use this section to search for DICOM studies using DICOM Web QIDO-RS.</p>
            <form onSubmit={handleSearch} className="qido-form">
                <input className="qido-input" name="PatientName" placeholder="PatientName" value={form.PatientName} onChange={handleChange} />
                <input className="qido-input" name="PatientID" placeholder="PatientID" value={form.PatientID} onChange={handleChange} />
                <input className="qido-input" name="StudyDate" placeholder="StudyDate (YYYYMMDD)" value={form.StudyDate} onChange={handleChange} />
                <input className="qido-input" name="Modality" placeholder="Modality" value={form.Modality} onChange={handleChange} />
                <input className="qido-input" name="StudyDescription" placeholder="StudyDescription" value={form.StudyDescription} onChange={handleChange} />
                <button
                    type="submit"
                    className={"qido-button" + (serverUnreachable ? ' disabled' : '')}
                    disabled={serverUnreachable}
                    aria-disabled={serverUnreachable}
                    title={serverUnreachable ? 'DCM server unreachable' : undefined}
                >
                    Search
                </button>
            </form>

            {error && <div>{error}</div>}
            {isLoading && <div>Loading...</div>}

            {results && (
                <StudyList studies={results} title={`Results (${results.length})`} />
            )}
        </div>
    );
}

export default DicomWeb;
